export const DEFAULT_BALANCE_TYPES = [
  {
    id: 'in',
    text: 'In',
  },
  {
    id: 'out',
    text: 'Out',
  },
  {
    id: 'in_out',
    text: 'In/Out',
  },
];

export const DEFAULT_STATEMENT_BALANCE_TYPES = [
  {
    id: 'all',
    text: 'All types',
  },
  ...DEFAULT_BALANCE_TYPES,
];
